import { useTranslation } from 'react-i18next'
import {
  Dialog,
  DialogContent,
  DialogHeader,
  DialogTitle,
  DialogDescription,
  DialogFooter,
} from '@/shared/components/ui/dialog'
import { Button } from '@/shared/components/ui/button'
import { useTour } from './use-tour'

/**
 * Full-screen modal for tour steps that have no targetSelector
 * (conceptual explanations between spotlight steps).
 */
export function TourWelcomeModal() {
  const { t } = useTranslation()
  const { activeChapter, currentStepIndex, currentStep, totalSteps, nextStep, prevStep, skipChapter, nextGroupChapter } =
    useTour()

  if (currentStepIndex === null || !currentStep || !activeChapter) return null
  // Only render for steps without a targetSelector
  if (currentStep.targetSelector) return null

  const isLast = currentStepIndex === totalSteps - 1
  const lastLabel = nextGroupChapter
    ? t('tour.common.nextChapter', 'Next: {{chapter}}', { chapter: nextGroupChapter })
    : t('tour.common.done', 'Done')

  return (
    <Dialog
      open
      onOpenChange={(open) => {
        if (!open) skipChapter()
      }}
    >
      <DialogContent showCloseButton={false} className="sm:max-w-md [&]:top-[40%]">
        <DialogHeader>
          <DialogTitle className="text-[17px] font-semibold">
            {t(`tour.step.${activeChapter.id}.${currentStep.id}.title`, currentStep.title)}
          </DialogTitle>
          <DialogDescription className="text-[14px] leading-[1.65] text-[var(--ink)]">
            {t(`tour.step.${activeChapter.id}.${currentStep.id}.body`, currentStep.body)}
          </DialogDescription>
        </DialogHeader>
        <DialogFooter className="gap-2">
          <Button variant="ghost" onClick={skipChapter}>
            {t('tour.common.skip', 'Skip')}
          </Button>
          {currentStepIndex > 0 && (
            <Button variant="outline" onClick={prevStep}>
              {t('tour.common.back', 'Back')}
            </Button>
          )}
          <Button onClick={nextStep}>
            {isLast ? lastLabel : t('tour.common.next', 'Next')}
          </Button>
        </DialogFooter>
      </DialogContent>
    </Dialog>
  )
}
